export default {
  title: 'Dane kontaktowe',
  form: {
    customer_first_name: {
      placeholder: 'Imię',
    },
    customer_last_name: {
      placeholder: 'Nazwisko',
    },
    customer_email: {
      placeholder: 'Adres e-mail',
    },
    customer_phone_number: {
      placeholder: 'Numer telefonu',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Podaj swoje imię',
    },
    customer_last_name: {
      required: 'Podaj swoje nazwisko',
    },
    customer_email: {
      required: 'Podaj swój adres e-mail',
    },
    customer_phone_number: {
      required: 'Podaj swój numer telefonu',
    },
  },
};
